import axios from 'axios';

export const AppVersionService = {
  async getAppVersions({ page, perPage }) {
    const params = {
      page,
      size: perPage,
    };

    const res = await axios.get(`mobile/appVersion/all/`, {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createAppVersion(data) {
    const res = await axios.post('mobile/appVersion/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async deleteAppVersion(id) {
    const res = await axios.delete(`mobile/appVersion/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateAppVersion(id, data) {
    const res = await axios.put(`mobile/appVersion/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
